import { string } from 'yup';
import type { StringSchema } from 'yup';

export interface TextValidatorInterface {
  fieldName: string;
  minLength?: number;
  maxLength?: number;
  regExp?: RegExp;
  length?: number;
  readableFieldName?: string; // это нужно если валидатор запускается вручную и нужно вывести вменяемое название поля
  required?: boolean;
  requireTextAndNumbers?: boolean;
  withoutSymbols?: boolean;
  withoutSpaces?: boolean; // поле не должно содержать пробелы
  lengthMessage?: string;
}

export const textValidator = ({
  fieldName,
  minLength,
  maxLength,
  length,
  regExp,
  readableFieldName,
  required = true,
  requireTextAndNumbers,
  withoutSymbols,
  withoutSpaces,
  lengthMessage,
}: TextValidatorInterface): StringSchema<
  string | null | undefined,
  Record<string, unknown>,
  string | null | undefined
> => {
  const readableName = readableFieldName ? `"${readableFieldName}" ` : '';
  return string()
    .nullable()
    .test(fieldName, `Поле ${readableName}должно быть заполнено`, (value) => !(!value && required))
    .test(
      fieldName,
      `Поле ${readableName}не может состоять из пробелов`,
      (value) => !(value && `${value}`.match(/^\s+$/)),
    )
    .test(fieldName, `Поле ${readableName}не может начинаться с пробела`, (value) => !(value && value.match(/^\s+/)))
    .test(fieldName, `Поле ${readableName}не должно оканчиваться на пробел`, (value) => !(value && value.match(/\s+$/)))
    .test(
      fieldName,
      lengthMessage ||
        `Поле (или ключ поля) ${readableName} должно содержать определенное количество символов (${length})`,
      (value) => length === undefined || !(value && typeof value === 'string' && value.trim().length !== length),
    )
    .test(
      fieldName,
      `Минимальное количество символов у поля ${readableName}- ${minLength}`,
      (value) => minLength === undefined || !(value && typeof value === 'string' && value.trim().length < minLength),
    )
    .test(
      fieldName,
      `Максимальное количество символов у поля ${readableName}- ${maxLength}`,
      (value) => maxLength === undefined || !(value && typeof value === 'string' && value.trim().length > maxLength),
    )
    .test(
      fieldName,
      `Поле ${readableName}не прошло проверку условия`,
      (value) => !!(regExp === undefined || (value && `${value}`.match(regExp))),
    )
    .test(
      fieldName,
      `Поле ${readableName}не должно состоять из символов`,
      (value) =>
        requireTextAndNumbers === undefined || (typeof value === 'string' && !!value.match(/[A-zА-Яа-яЁё0-9]+/)),
    )
    .test(fieldName, `Поле ${readableName}не должно содержать символы`, (value) => {
      if (!withoutSymbols) return true;
      return withoutSymbols && value
        ? typeof value === 'string' && !!value.match(/^[A-zА-Яа-яЁё\d\s/\[\]?!.,:'"()_-]+$/)
        : true;
    })
    .test(fieldName, `Поле ${readableName}не должно содержать пробелы`, (value) => {
      if (!withoutSpaces) return true;
      return withoutSpaces && value ? typeof value === 'string' && !value.includes(' ') : true;
    });
};
